<template>
  <section class="section section-stages">
    <div class="container container-small">
      <header class="section-header">
        <AccentHeader :underline="true" :header="header" :uppercase="false"/>
      </header>
      <div class="stages">
        <div class="items-wrapper" v-if="!isMobile">
          <div
            class="item"
            :style="{left: (index * 100 / (items.length - 1)) + '%'}"
            v-for="(item, index) in items" :key="index"
            :class="{
              active: index == activeItem
            }"
            @click="setActive(index)"
          >
            <span class="label">{{item.label}}</span>
          </div>
        </div>
        <div class="items-wrapper" v-else>
          <div
            class="item"
            :style="{left: ((index + 1) * 23) + '%'}"
            v-for="(item, index) in [1, 2, 3, 4]" :key="index"
            :class="{
              active: index == 0
            }"
            @click="setActive((activeItem + index)%(items.length))"
          >
            <span class="label">{{('0'+ ((activeItem + index + 1)%(items.length) || 10)).slice(-2)}}</span>
          </div>
        </div>
        <SwipeHandler class="content-wrapper" @swipeLeft="swipeLeft" @swipeRight="swipeRight">
          <SliderControllers v-if="isMobile" @showPrev="showPrev" @showNext="showNext" :displayPrev="true" :displayNext="true" :small="true"/>
          <div
            class="content"
            :class="{
              active: index == activeItem,
              right: index + 1 > (items.length + 1) / 2
            }"
            v-for="(item, index) in items" :key="'content' +index"
            :style="{left: (index * 100 / (items.length - 1)) + '%'}"
          >
            <transition name="pulse" >
              <div class="animation-wrapper" v-if="index == activeItem">
                <div class="img-wrapper">
                  <img :src="item.image" :alt="item.label">
                </div>
                <div class="content-right">
                  <AccentHeader :underline="false" :header="item.header" :uppercase="false"/>
                  <p v-accent="item.description">
                  </p>
                </div>
              </div>
            </transition>
          </div>
        </SwipeHandler>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import AccentHeader from '@/components/AccentHeader.vue'
import SliderControllers from '@/components/SliderControllers.vue'
import SwipeHandler from '@/components/SwipeHandler.vue'

export default {
  name: 'stagesSection',
  props: ['header', 'items', 'buttonUp'],
  components: {
    AccentHeader,
    SliderControllers,
    SwipeHandler
  },
  data: function () {
    return {
      activeItem: 4,
      loop: true,
      loopTimeout: null
    }
  },
  methods: {
    swipeLeft () {
      this.showNext()
    },
    swipeRight () {
      this.showPrev()
    },
    showNext () {
      this.activeItem = this.activeItem + 1 < this.items.length
        ? Math.min(this.activeItem + 1, this.items.length - 1)
        : 0
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    loopNext () {
      if (this.loop) {
        this.activeItem = this.activeItem + 1 < this.items.length
          ? Math.min(this.activeItem + 1, this.items.length - 1)
          : 0
        this.loopTimeout = window.setTimeout(() => {
          this.loopNext()
        }, 1000)
      }
    },
    showPrev () {
      this.activeItem = this.activeItem - 1 >= 0
        ? Math.max(this.activeItem - 1, 0)
        : this.items.length - 1
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    setActive (index) {
      this.activeItem = index
    }
  },
  computed: {
    ...mapGetters([
      'breakpoint'
    ]),
    isMobile () {
      return this.breakpoint === 'mobile' || this.breakpoint === 'tablet'
    }
  },
  mounted () {
    // setTimeout(this.loopNext, 1000)
  }
}
</script>

<style scoped lang="scss">
  .button-scroll {
    bottom: -10px;;
  }
  .content-wrapper {
    @include tablet {
      position: relative;
    }
    .controllers {
      position: absolute;
      top: 40px;
      right: 0;
      width: 100px;
      z-index: 99999;
      display: none;
      @include tablet {
        display: block;
      }
    }
  }
  .section {
    padding: 40px 0;
    overflow: hidden;
    position: relative;
    min-height: 670px;
    .font-size-l & {
      min-height: 720px;
    }
  }
  .section-header {
    max-width: 320px;
  }
  .stages {
    margin: 100px auto 0;
    position: relative;
    min-height: 380px;
    width: 90%;
    @include tablet {
      width: 100%;
      padding-right: 40px;
    }
  }
  .items-wrapper {
    border-top: 2px solid $bg-dark;
    width: 100%;
    position: relative;
    z-index: 2;
    @include biger-then-tablet {
      transform: translateX(0) !important;
    }
    @include tablet {
      position: relative;
      min-height: 10px;
      width: 150%;
      left: 20px;
      transform: translateX(-25%);
    }
  }
  .item {
    position: absolute;
    top: 0;
    transform: translate(-50%, -50%);
    width: 16px;
    height: 16px;
    z-index: 1;
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 16px;
      height: 16px;
      border: 2px solid $bg-dark;
      border-radius: 50%;
      background-color: $bg-light;
      .hight-contrast & {
        border: 2px solid $contrast-accent;
        background-color: $contrast-bg;
      }

    }
    // &:nth-child(4) {
    //   .content {
    //     display: block;
    //   }
    // }
    cursor: pointer;
    .label {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -150%);
      font-weight: 500;
    }

    &.active {
      &:before {
        border: 2px solid $text-accent;
        animation-name: pulse1;
        animation-timing-function: ease-in-out;
        animation-iteration-count: 1;
        animation-duration: 0.5s;
        z-index: 9999;
        .hight-contrast & {
          border: 2px solid $contrast-accent;
        }
      }
      z-index: 9999;
    }
  }
  .pulse-enter-active {
    animation: {
      name: pulse2;
      timing-function: ease-in-out;
      iteration-count: 1;
      duration: 0.5s;
    }
  }
  .content {
    display: none;
    background-color: $bg-light;
    position: absolute;
    top: 15px;
    left: 50%;
    // transform: translateX(-50%);
    padding: 10px 40px;
    min-width: 420px;
    @include tablet {
      position: static;
      margin-top: 40px;
      min-width: 100px;
      width: 100%;
      padding: 0;
      left: 0;
    }
    &.active {
      display: block;
    }
    &:after {
      content: '';
      display: block;
      width: 2px;
      height: 165px;
      position: absolute;
      top: -7px;
      left: -1px;
      background-color: $text-accent;
      .hight-contrast & {
        background-color: $contrast-accent;
      }
      @include tablet {
        display: none;
      }
    }
    .img-wrapper {
      margin: 10px 0 0;
      border-radius: 50%;
      overflow: hidden;
      width: 90px;
      height: 90px;
      text-align: center;
      img {
        border-radius: 50%;
        max-width: 100%;
        max-height: 100%;
      }
    }
    &.right {
      @include biger-then-tablet {
        transform: translateX(-100%);
      }
      &:after {
        content: '';
        right: -1px;
        left: auto;
      }
    }
  }
  .content-right {
    max-width: 330px;
    /deep/ h2 {
      span {
        display: block;
      }
    }
    p {
      font-weight: 500;
    }
    @include tablet {
      width: 100%;
      max-width: 100%;
    }
  }
  @keyframes pulse1 {
    from {
      transform: scale3d(1, 1, 1);
    }

    50% {
      transform: scale3d(1.25, 1.25, 1.25);
    }

    to {
      transform: scale3d(1, 1, 1);
    }
  }
  @keyframes pulse2 {
    from {
      transform: scale3d(1, 1, 1);
    }

    50% {
      transform: scale3d(1.05, 1.05, 1.05);
    }

    to {
      transform: scale3d(1, 1, 1);
    }
  }
</style>
